import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # MedicalDeviceInfo
 *
 * MedicalDeviceInfo을 설명하세요.
 */
export const MedicalDeviceInfo = types
  .model('MedicalDeviceInfo')
  // --------------------------------------------------------------------------
  .props({
    medicalDeviceSid: types.number,
    productVer: types.string,
    medicalDeviceConts: types.string,
    langCd: types.string,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model medicalDeviceInfo --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IMedicalDeviceInfo;
      (Object.keys(newProps) as TMedicalDeviceInfoKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMedicalDeviceInfo = Instance<typeof MedicalDeviceInfo>;
type TMedicalDeviceInfoSnapshot = SnapshotOut<typeof MedicalDeviceInfo>;

export interface IMedicalDeviceInfo extends TMedicalDeviceInfo {}
export type TMedicalDeviceInfoKeys = keyof TMedicalDeviceInfoSnapshot & string;
export interface IMedicalDeviceInfoSnapshot extends TMedicalDeviceInfoSnapshot {}
export const createMedicalDeviceInfo = () =>
  types.optional(MedicalDeviceInfo, {} as TMedicalDeviceInfo);
